import Vue from 'vue';
import exchangeRateConversion from './exchange-rate-conversion/exchange-rate-conversion';
import store from '../common/js/vuex/store';
import exchangeRateAfirStore from './exchange-rate-conversion/exchange-rate-conversion-vuex';
if (!store.hasModule(['exchangeRateConversion'])) {
	store.registerModule('exchangeRateConversion', exchangeRateAfirStore);
}
Vue.component('exchange-rate-conversion', exchangeRateConversion);
